<template>
    <button @click="$emit('click', $event)" class="shadow-button">
        <i :class="icon">
            <span v-show="badge && badge > 0" class="badge">{{ badge }}</span>
        </i>
        <span class="title">
            <slot></slot>
        </span>
    </button>
</template>

<script>
export default {
    name: "ShadowButton",
    props: {
        badge: {
            type: Number
        },
        icon: {
            required: true,
            type: String
        }
    }
};
</script>

<style scoped lang="scss">
.shadow-button {
    background: none;
    border: none;
    display: block;
    cursor: pointer;
    position: relative;
    border-radius: 10px;
    margin-bottom: 30px;

    .icon {
        height: 65px;
        box-shadow: 0 0 13px -6px #13203a;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        width: 60px;
        font-size: 18px;
        margin: 0 auto;
        position: relative;
        background-color: #ffffff;

        &.icon-vip {
            font-size: 25px;
        }

        &.icon-giftcard {
            font-size: 20px;
        }

        .badge {
            position: absolute;
            font-family: 'iran-sans', sans-serif;
            background-size: 100% 100%;
            top: -10px;
            left: -9px;
            color: #fff;
            border-radius: 50%;
            width: 23px;
            height: 23px;
            display: block;
            line-height: 22px;
            text-align: center;
            padding-top: 2px;
            font-size: 9px;
        }
    }

    .title {
        display: block;
        margin-top: 7px;
        font-weight: 700;
        font-size: 12px;
    }
}
</style>
